import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
type ModalType = 'privacy' | 'terms' | null;
export function Footer() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  // Prevent scrolling on body when modal is open
  useEffect(() => {
    if (activeModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [activeModal]);
  return <>
      <footer className="py-8 px-4 border-t border-white/5 bg-[#050505] relative z-10" data-id="element-11">
        <div className="max-w-4xl mx-auto flex flex-col items-center justify-center gap-4" data-id="element-12">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400" data-id="element-13">
            <button onClick={() => setActiveModal('privacy')} className="hover:text-[#25D366] transition-colors" data-id="element-14">
              Política de Privacidad
            </button>
            <button onClick={() => setActiveModal('terms')} className="hover:text-[#25D366] transition-colors" data-id="element-15">
              Términos y Condiciones
            </button>
          </div>
          <p className="text-gray-600 text-xs text-center" data-id="element-16">
            © {new Date().getFullYear()} ilumente.com — Todos los derechos
            reservados.
            <br data-id="element-17" />
            Este sitio no es parte del sitio web de Facebook o Meta Inc.
          </p>
        </div>
      </footer>

      <AnimatePresence data-id="element-18">
        {activeModal && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-19">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setActiveModal(null)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-20" />

            <motion.div initial={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} animate={{
          opacity: 1,
          y: 0,
          scale: 1
        }} exit={{
          opacity: 0,
          y: 20,
          scale: 0.95
        }} className="relative w-full max-w-2xl max-h-[85vh] bg-[#111] border border-white/10 rounded-2xl shadow-2xl flex flex-col overflow-hidden" data-id="element-21">
              {/* Header */}
              <div className="flex items-center justify-between p-6 border-b border-white/10 bg-[#161616]" data-id="element-22">
                <h3 className="text-xl font-bold text-white" data-id="element-23">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="p-2 text-gray-400 hover:text-white hover:bg-white/10 rounded-full transition-colors" data-id="element-24">
                  <X className="w-5 h-5" data-id="element-25" />
                </button>
              </div>

              {/* Content */}
              <div className="p-6 overflow-y-auto text-gray-300 text-sm leading-relaxed space-y-6 custom-scrollbar" data-id="element-26">
                {activeModal === 'privacy' ? <>
                    <section data-id="element-27">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-28">
                        1. Información que recopilamos
                      </h4>
                      <p data-id="element-29">
                        Recopilamos información cuando visitas nuestro sitio,
                        realizas una compra o interactúas con nuestros anuncios.
                        Esto incluye datos de navegación (cookies, píxeles de
                        seguimiento como Meta Pixel) y la información
                        proporcionada durante el proceso de pago (nombre, correo
                        electrónico, datos de facturación procesados de forma
                        segura por Shopify o Mercado Pago).
                      </p>
                    </section>
                    <section data-id="element-30">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-31">
                        2. Uso de la información
                      </h4>
                      <p data-id="element-32">
                        Utilizamos la información recopilada para: procesar tus
                        transacciones y entregar el producto digital, mejorar
                        nuestro sitio web y ofertas, personalizar tu
                        experiencia, y enviar correos electrónicos periódicos
                        relacionados con tu compra o promociones exclusivas.
                      </p>
                    </section>
                    <section data-id="element-33">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-34">
                        3. Protección de datos
                      </h4>
                      <p data-id="element-35">
                        Implementamos una variedad de medidas de seguridad para
                        mantener la seguridad de tu información personal. No
                        vendemos, intercambiamos ni transferimos a terceros tu
                        información personal identificable, excepto a los
                        proveedores de servicios de confianza (como pasarelas de
                        pago) que nos ayudan a operar nuestro sitio web.
                      </p>
                    </section>
                    <section data-id="element-36">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-37">
                        4. Uso de Cookies y Píxeles
                      </h4>
                      <p data-id="element-38">
                        Utilizamos cookies y tecnologías similares (como Meta
                        Pixel) para entender y guardar tus preferencias para
                        futuras visitas, y recopilar datos agregados sobre el
                        tráfico del sitio y la interacción para ofrecer mejores
                        experiencias y herramientas en el futuro.
                      </p>
                    </section>
                    <section data-id="element-39">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-40">
                        5. Consentimiento
                      </h4>
                      <p data-id="element-41">
                        Al utilizar nuestro sitio, aceptas nuestra política de
                        privacidad. Nos reservamos el derecho de modificar esta
                        política en cualquier momento.
                      </p>
                    </section>
                  </> : <>
                    <section data-id="element-42">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-43">
                        1. Naturaleza del Producto
                      </h4>
                      <p data-id="element-44">
                        "Vendedor de Hierro" es un producto digital (curso/ebook
                        y plantillas). Al realizar la compra, obtienes acceso
                        inmediato al material. No se enviará ningún producto
                        físico a tu domicilio.
                      </p>
                    </section>
                    <section data-id="element-45">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-46">
                        2. Propiedad Intelectual
                      </h4>
                      <p data-id="element-47">
                        Todo el contenido, textos, videos, plantillas y
                        materiales proporcionados están protegidos por derechos
                        de autor. Tu compra te otorga una licencia de uso
                        personal e intransferible. Está estrictamente prohibida
                        la reventa, distribución, copia o reproducción parcial o
                        total del material sin autorización expresa.
                      </p>
                    </section>
                    <section data-id="element-48">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-49">
                        3. Garantía de Devolución
                      </h4>
                      <p data-id="element-50">
                        Ofrecemos una garantía de satisfacción de 7 días. Si
                        dentro de los primeros 7 días posteriores a tu compra
                        consideras que el producto no cumple con tus
                        expectativas, puedes solicitar el reembolso del 100% de
                        tu dinero. Pasados los 7 días, no se emitirán reembolsos
                        bajo ninguna circunstancia.
                      </p>
                    </section>
                    <section data-id="element-51">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-52">
                        4. Pagos y Facturación
                      </h4>
                      <p data-id="element-53">
                        Los pagos son procesados de forma segura a través de
                        plataformas de terceros (Shopify, Mercado Pago, etc.).
                        No almacenamos los datos de tu tarjeta de crédito. Los
                        precios están expresados en la moneda indicada en el
                        checkout y pueden estar sujetos a impuestos locales
                        según tu jurisdicción.
                      </p>
                    </section>
                    <section data-id="element-54">
                      <h4 className="text-white font-bold text-base mb-2" data-id="element-55">
                        5. Exención de Responsabilidad
                      </h4>
                      <p data-id="element-56">
                        Los resultados obtenidos al aplicar las estrategias de
                        "Vendedor de Hierro" pueden variar según el esfuerzo, la
                        dedicación y el nicho de mercado de cada usuario. No
                        garantizamos ingresos específicos ni resultados exactos.
                      </p>
                    </section>
                  </>}
              </div>

              {/* Footer Action */}
              <div className="p-4 border-t border-white/10 bg-[#161616] flex justify-end" data-id="element-57">
                <button onClick={() => setActiveModal(null)} className="px-6 py-2 bg-white/10 hover:bg-white/20 text-white rounded-lg font-medium transition-colors" data-id="element-58">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>
    </>;
}